import { Users } from "lucide-react";
import type { TeamHub as TeamHubType } from "@/types";
import { getRoleConfig } from "./utils";

export function MembersTab({ hub }: Readonly<{ hub: TeamHubType }>) {
  return (
    <div className="p-6">
      {hub.members.length > 0 ? (
        <div className="bg-surface-primary border border-border-primary rounded-lg overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="border-b border-border-primary bg-surface-primary/50">
                <th className="text-left px-6 py-3 text-xs font-medium text-content-tertiary uppercase tracking-wider">
                  Member
                </th>
                <th className="text-left px-6 py-3 text-xs font-medium text-content-tertiary uppercase tracking-wider">
                  Role
                </th>
                <th className="text-left px-6 py-3 text-xs font-medium text-content-tertiary uppercase tracking-wider">
                  Joined
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border-primary">
              {hub.members.map((member) => {
                const roleConfig = getRoleConfig(member.role);
                const RoleIcon = roleConfig.icon;
                return (
                  <tr key={member.userUuid} className="hover:bg-interactive-hover transition-colors">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className="h-9 w-9 rounded-full bg-linear-to-br from-brand-primary/30 to-brand-secondary/30 flex items-center justify-center shrink-0">
                          <span className="text-sm font-medium text-content-primary">
                            {(member.name || member.email).charAt(0).toUpperCase()}
                          </span>
                        </div>
                        <div className="min-w-0">
                          <p className="text-sm font-medium text-content-primary truncate">
                            {member.name || "Unnamed User"}
                          </p>
                          <p className="text-xs text-content-tertiary truncate">{member.email}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md ${roleConfig.bg}`}>
                        <RoleIcon className={`h-3 w-3 ${roleConfig.color}`} />
                        <span className={`text-xs font-medium ${roleConfig.color}`}>{roleConfig.label}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-sm text-content-tertiary">
                      {new Date(member.joinedAt).toLocaleDateString()}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-16">
          <Users className="h-8 w-8 text-content-quaternary mb-2" />
          <p className="text-sm text-content-tertiary">No members found.</p>
        </div>
      )}
    </div>
  );
}
